export default __webpack_public_path__ + "static/media/city-hall-website.64fca599.svg";